<div class="shop-max-header">
    <div>
        {{'departmentCapacity.shopMaxSlotsPerDay'| translate}} 
    </div>
</div>

<ng-container *ngIf="shopMaxDetails.controls.length" [formGroup]="shopMaxForm">
    <table formArrayName="shopMaxDetails" class="alternateColor" aria-describedby="">
        <th id="header" style="width : 10%">
                <div class="inherit-font-size form-control m-2 border-0">{{'departmentCapacity.total'| translate}}</div>
           
                <div class=" form-control m-2 border-0" style="font-size : 0.5rem; background: #f5f6f8;
                height: 3rem; margin: 0 !important;"></div>
           
                <div class="inherit-font-size form-control m-2 border-0">{{totalCapacity}}</div>
        </th>
        <td *ngFor="let day of shopMaxDetails.controls; let i = index" [formGroupName]="i">
            <tr>
                <div class="inherit-font-size form-control m-2 border-0" style="margin-left: -1rem !important">{{getWeekDays(day.value.dayOfWeek)}}</div>
            </tr>
            <tr >
                <div class="form-control m-2 border-0" style="font-size : 0.7rem; margin-left: -0.7rem !important">{{day.value.hoursOfOperation === 'Closed' ? ('departmentCapacity.closed'| translate): day.value.hoursOfOperation   }}</div>
            </tr>
            <tr >
                <input [readonly]="day.value.hoursOfOperation === 'Closed'" type="number" min="0" class="form-control m-2" formControlName="slotCapacity" />
            </tr>
        </td>
    </table>
    <div class="controls" *ngIf="viewMode == 'Team'">
        <div class="cancel"(click)="onCancel()" 
        [ngClass]="isSaveClicked ?'enabled':''">
        Cancel
        </div>
        <div class="save" (click)="onSave()" 
        [ngClass]="isSaveClicked ?'enabled':''">
        Save
        </div>
    </div>
</ng-container>